import styled from 'styled-components';

interface ContentProps {
  joinContent?: boolean;
  noGap?: boolean;
}

export const Container = styled.section`
  padding: 32px 0 48px 0;

  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 32px;

    padding-left: 0;
    padding-right: 0;
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: 20px 16px 32px 16px;
  }
`;

export const Content = styled.div<ContentProps>`
  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: ${({ joinContent }) => (joinContent ? '1fr' : '1fr 1fr')};
    grid-gap: ${({ noGap }) => (noGap ? 0 : 32)}px;
  }
`;

export const Title = styled.h3`
  font-weight: 600;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.group.section.title};
`;

export const Details = styled.p`
  margin-bottom: 16px;
  color: ${({ theme }) => theme.group.section.details};
`;
